import { AfterViewInit, Directive, inject, OnChanges, OnInit } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Directive({
  selector: 'mat-slide-toggle[ctrColorSlideToggle]',
  standalone: true,
})
export class SlideToggleColorDirective implements OnInit, OnChanges, AfterViewInit {
  hotelColor = '#000';

  private elementRef = inject(MatSlideToggle);

  /**
   * Lifecycle hook that is called after the directive's data-bound properties have been initialized.
   * Retrieves the primary and contrast colors from the CSS variables.
   */
  ngOnInit(): void {
    this.hotelColor = getComputedStyle(document.body).getPropertyValue('--ctr-primary-color');
  }

  /**
   * Lifecycle hook that is called after the view has been initialized.
   * Sets the color of the slide toggle.
   */
  ngAfterViewInit(): void {
    this.hotelColor = getComputedStyle(document.body).getPropertyValue('--ctr-primary-color');
    this.setColor();
  }

  /**
   * Lifecycle hook that is called when any input property changes.
   * Sets the color of the slide toggle.
   */
  ngOnChanges(): void {
    this.setColor();
  }

  setColor() {
    const trackOpacity = '90';
    const unselectedColor = '#fafafa';
    const element = this.elementRef['_elementRef']?.nativeElement as HTMLElement;
    if (!element) return;

    element.style.setProperty('--mat-slide-toggle-selected-handle-color', this.hotelColor);
    element.style.setProperty('--mat-slide-toggle-selected-pressed-handle-color', this.hotelColor);
    element.style.setProperty('--mat-slide-toggle-selected-hover-handle-color', this.hotelColor);
    element.style.setProperty('--mat-slide-toggle-selected-focus-handle-color', this.hotelColor);
    element.style.setProperty('--mat-slide-toggle-selected-pressed-track-color', this.hotelColor + trackOpacity);
    element.style.setProperty('--mat-slide-toggle-selected-track-color', this.hotelColor + trackOpacity);
    element.style.setProperty('--mat-slide-toggle-selected-focus-track-color', this.hotelColor + trackOpacity);
    element.style.setProperty('--mat-slide-toggle-selected-hover-track-color', this.hotelColor + trackOpacity);
    element.style.setProperty('--mat-slider-hover-state-layer-color', this.hotelColor + '05');
    element.style.setProperty('--mat-slider-focus-state-layer-color', this.hotelColor + '20');

    element.style.setProperty('--mdc-switch-selected-handle-color', this.hotelColor);
    element.style.setProperty('--mdc-switch-selected-pressed-handle-color', this.hotelColor);
    element.style.setProperty('--mdc-switch-selected-hover-handle-color', this.hotelColor);
    element.style.setProperty('--mdc-switch-selected-focus-handle-color', this.hotelColor);
    element.style.setProperty('--mdc-switch-selected-pressed-track-color', this.hotelColor + trackOpacity);
    element.style.setProperty('--mdc-switch-selected-track-color', this.hotelColor + trackOpacity);
    element.style.setProperty('--mdc-switch-selected-focus-track-color', this.hotelColor + trackOpacity);
    element.style.setProperty('--mdc-switch-selected-hover-track-color', this.hotelColor + trackOpacity);
    element.style.setProperty('--mdc-slider-hover-state-layer-color', this.hotelColor + '05');
    element.style.setProperty('--mdc-slider-focus-state-layer-color', this.hotelColor + '20');
    element.style.setProperty('--mdc-switch-selected-hover-state-layer-color', this.hotelColor + '20');
    element.style.setProperty('--mdc-switch-selected-pressed-state-layer-color', this.hotelColor + '20');
    element.style.setProperty('--mdc-switch-selected-focus-state-layer-color', this.hotelColor);

    // set color when unselcted
    element.style.setProperty('--mat-slide-toggle-unselected-handle-color', unselectedColor);
    element.style.setProperty('--mat-slide-toggle-unselected-pressed-handle-color', unselectedColor);
    element.style.setProperty('--mat-slide-toggle-unselected-hover-handle-color', unselectedColor);
    element.style.setProperty('--mat-slide-toggle-unselected-focus-handle-color', unselectedColor);

    element.style.setProperty('--mdc-switch-unselected-handle-color', unselectedColor);
    element.style.setProperty('--mdc-switch-unselected-pressed-handle-color', unselectedColor);
    element.style.setProperty('--mdc-switch-unselected-hover-handle-color', unselectedColor);
    element.style.setProperty('--mdc-switch-unselected-focus-handle-color', unselectedColor);
  }
}
